/* eslint-disable no-unused-vars */
import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import { Link } from "react-scroll";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazy-load";
// imported image
import avatar from "../img/avatar.png";
const Home = () => {
  return (
    <article
      aria-label="short note about me"
      className="relative grid mx-auto mt-4 text-white duration-500 md:grid-cols-3 sm:rounded-md hover:shadow-xl shadow-slate-800 sm:w-11/12 xm:mt-1 sm:px-8 bg-slate-800/80 backdrop-blur-sm backdrop-brightness50"
    >
      <div className="max-w-4xl  text-clip col-span-2 justify-center space-y-0.5 p-6 sm:p-12  flex flex-col">
        <p
          aria-label="hii my name is"
          className="py-1 font-sans font-extrabold text-cyan-500/50 sm:text-xl"
        >
          Hii! my name is
        </p>
        <figure
          aria-label="avatar pic"
          className="flex items-start justify-start md:hidden"
        >
          {" "}
          <LazyLoad>
            <img
              src={avatar}
              height="250px"
              className="py-3 rounded-full"
              alt="avatar"
              width="250px"
            />
          </LazyLoad>
        </figure>
        <h2 className="text-4xl font-bold sm:text-6xl text-cyan-300">
          {"Arun Tiwari"}
        </h2>
        <h1 className="text-2xl font-semibold break-all sm:text-5xl text-cyan-600">
          {"I'm a Frontend Developer"}
        </h1>
        <p
          aria-label="short story"
          className="max-w-3xl py-4 break-all text-cyan-200/90"
        >
          {
            "A entry-level front-end developer with some ux skills as well have entry level experience in building UI's have exceptional digital experiences and a collaborative nature. Currently, I'm focused on making responsive UI's for web application and mainly working as Ui developr in webkul software pvt. ltd."
          }
          <NavLink
            to="about"
            className="text-xs md:text-[0.2rem] duration-300 hover:text-xs hover:text-white text-gray-400 "
          >
            {"  Read more..."}
          </NavLink>
        </p>
        <div>
          <Link to="Work" smooth={true} duration={500}>
            <button
              type="button"
              className="flex items-center justify-center px-6 py-3 border-2 group hover:border-cyan-900 rounded-xl hover:bg-cyan-900"
            >
              {" View Work"}
              <HiArrowNarrowRight
                size={26}
                aria-label="arrow"
                className="ml-3 duration-700 group-hover:animate-pulse group-hover:rotate-90 "
              />
            </button>
          </Link>
        </div>
      </div>
      <figure
        aria-label="avatar pic"
        className="items-start justify-end hidden md:flex"
      >
        <LazyLoad>
          <img
            src={avatar}
            height="500px"
            className="py-5 rounded-full"
            alt="avatar"
            width="500px"
          />
        </LazyLoad>
      </figure>
    </article>
  );
};

export default Home;
